import { NextApiResponse } from 'next';

type TListCookie = {
  'list-project-key': string;
  'is-allowed': boolean;
  'expire-date': string; // ISO date string or custom format
};

export function setListServerCookie(
  res: NextApiResponse,
  data: TListCookie,
  daysValid: number
) {
  const json = JSON.stringify(data);
  const encoded = encodeURIComponent(json);

  const expires = new Date();
  expires.setDate(expires.getDate() + daysValid);

  res.setHeader(
    'Set-Cookie',
    `private-list=${encoded}; Path=/; Expires=${expires.toUTCString()}; HttpOnly; SameSite=Strict`
  );
}

export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() ?? '';
};

export const setCookie = (name: string, value: string, maxAgeSeconds = 31536000) => {
  document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSeconds}`;
};